import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.205 4.205A.7.7 0 0 1 4.7 4h10.6a.7.7 0 0 1 .7.7v1.452a.7.7 0 0 1-.149.431l-3.592 4.594v3.18a.7.7 0 0 1-.497.67l-3.118.943a.7.7 0 0 1-.903-.67v-4.123L4.15 6.583A.7.7 0 0 1 4 6.153V4.7a.7.7 0 0 1 .205-.495ZM5.4 5.4v.51l3.593 4.594a.7.7 0 0 1 .148.431v3.422l1.718-.52v-2.902a.7.7 0 0 1 .149-.431L14.6 5.911V5.4H5.4Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
